import { ErrorHandler } from "../lib/ErrorHandler";
import { extractErrorDetails } from "../lib/balances/errorUtils";
import { classifyNodeError } from "../lib/balances/nodeErrorClassifier";
export class BalanceProvider {
    constructor() {
        this.resolveTokenBalanceFetchError = (err, token, network, isNativeCurrency) => {
            ErrorHandler({
                type: 'BalanceProviderError',
                message: err.message,
                name: err.name,
                stack: err.stack,
                cause: err
            });
            const errorDetails = extractErrorDetails(err);
            const category = classifyNodeError(err);
            const tokenBalance = {
                network: network.name,
                token: token.symbol,
                amount: undefined,
                request_time: new Date().toJSON(),
                decimals: Number(token?.decimals),
                isNativeCurrency: isNativeCurrency ?? !token.contract,
                error: {
                    message: errorDetails.message,
                    name: errorDetails.name,
                    stack: errorDetails.stack,
                    code: errorDetails.code,
                    status: errorDetails.status,
                    statusText: errorDetails.statusText,
                    responseData: errorDetails.responseData,
                    requestUrl: errorDetails.requestUrl,
                    category: category
                }
            };
            return tokenBalance;
        };
    }
}
